import { PaymentTrackerStore, AnyStore, DisposersStore, BooleanStore } from 'stores';

import { SmartLink } from '../types';
import { ChangeDistanceStore } from './changeDistance';
import { ConfirmationStore } from './confirmationStore';
import { CouponsStore } from './coupons';
import { DisabledCustomFields } from './disabledCustomFields';
import { DisabledRegistrationFields } from './disabledRegistrationFields';
import { GiftcardsStore } from './giftcard';
import { PaymentStore } from './payment';
import { RacerRegistration } from './racerRegistration';
import { ServiceFeeStore } from './serviceFee.store';
import { StepperStore } from './stepper';
import { TransferStore } from './transfer';
import { TurnstileStore } from './turnstile';

const paymentTrackerStore = new PaymentTrackerStore();

const displayModalStore = new AnyStore(false);

/**
 * @description
 * disables custom fields in the form
 * by field id
 * used for the invited user(confirmation)
 */
const disabledCustomFieldsStore = new DisabledCustomFields();

/**
 * @description
 * disables registration fields (not custom fields) in the form
 * by field id
 * used for the edit registration
 */
const disabledRegistrationFieldsStore = new DisabledRegistrationFields();

const disposers = new DisposersStore();
const wavesStore = new AnyStore<WaveType[]>();

const distanceStore = new AnyStore<DistanceType>();
const distanceProductStore = new AnyStore<SelectedRaceProduct[]>();
const raceStore = new AnyStore<RacesType>();

/**
 * @description
 * Used for the dropdown selector
 */
const raceDistancesListStore = new AnyStore<DistanceType[]>();

/**
 * @description
 * Coupon data loaded and stores by coupon codes
 */
const couponsStore = new CouponsStore();

/**
 * @description
 * Giftcard data loaded and stores by giftcard codes
 */
const giftcardStore = new GiftcardsStore();

/**
 * @description
 * Store for sign in modal that can be triggered when inputted existed email
 */
const signInModalStore = new BooleanStore();

/**
 * @description
 * Leader email already taken,
 * CHECKS PERFORMED ONLY FOR LEADER EMAIL
 */
const emailExistsStore = new BooleanStore();

const stepperStore = new StepperStore();

/**
 * @description
 * payment settings and current payment data
 * used for the PaymentFrame, to perform actual payment
 * 'current' means that it is active payment that user currently filling in
 *
 */
const currentPaymentStore = new PaymentStore();

/**
 * @description
 * is payment popup opened
 */
const isPaymentFrameOpened = new BooleanStore();
const isPaymentSuccessfullyCompleted = new BooleanStore(false);
const isPaymentSucceeded = new AnyStore('');

const isOfflineStore = new BooleanStore();

const confirmationStore = new ConfirmationStore();
const transferStore = new TransferStore();
const changeDistanceStore = new ChangeDistanceStore();

const newSquadModalStore = new AnyStore<{ isOpen: boolean; id: string }>({ isOpen: false, id: '' });
const squadsStore = new AnyStore<AnyObject[]>();
const registrationClosedModalStore = new BooleanStore();
const racerRegistrationStore = new RacerRegistration();

const editRegistrationIdStore = new AnyStore<number>();
const smartLinkStore = new AnyStore<SmartLink>();
const isPayOnSiteSelectedStore = new BooleanStore();
const isPayOnLineSelectedStore = new BooleanStore();
const isPayWithEpassiSelectedStore = new BooleanStore();
const isPacePromoBannerEnabledStore = new BooleanStore();

const serviceFeeStore = new ServiceFeeStore();

/**
 * @description
 * Cloudflare Turnstile token for the registration submit
 */
const turnstileStore = new TurnstileStore();

export {
  isPacePromoBannerEnabledStore,
  changeDistanceStore,
  confirmationStore,
  couponsStore,
  CouponsStore,
  currentPaymentStore,
  disabledCustomFieldsStore,
  disabledRegistrationFieldsStore,
  displayModalStore,
  disposers,
  distanceProductStore,
  distanceStore,
  editRegistrationIdStore,
  emailExistsStore,
  giftcardStore,
  isOfflineStore,
  isPaymentFrameOpened,
  isPaymentSucceeded,
  isPaymentSuccessfullyCompleted,
  isPayOnLineSelectedStore,
  isPayWithEpassiSelectedStore,
  isPayOnSiteSelectedStore,
  newSquadModalStore,
  paymentTrackerStore,
  raceDistancesListStore,
  racerRegistrationStore,
  raceStore,
  registrationClosedModalStore,
  serviceFeeStore,
  signInModalStore,
  smartLinkStore,
  squadsStore,
  stepperStore,
  transferStore,
  turnstileStore,
  wavesStore,
};
